import React, { FC } from 'react';
import { CandidateProfileHeaderWithApplication } from './CandidateProfileHeaderWithApplication';
import { CandidateProfileHeaderWithUser } from './CandidateProfileHeaderWithUser';
import { CandidateProfileHeaderProps } from './props';
import './styles.scss';

export const CandidateProfileHeader: FC<CandidateProfileHeaderProps> = ({
  actions,
  applicationId,
  className,
  metricsContext,
  openingId,
  onClose,
  user,
}) => {
  if (applicationId) {
    return (
      <CandidateProfileHeaderWithApplication
        actions={actions}
        applicationId={applicationId}
        className={className}
        metricsContext={metricsContext}
        onClose={onClose}
        openingId={openingId}
      />
    );
  }

  return (
    <CandidateProfileHeaderWithUser actions={actions} metricsContext={metricsContext} onClose={onClose} user={user} />
  );
};
